import {
	type ClientPropertyItemResponseDTO,
	ClientPropertyTypeEnum,
	ClientPropertyVehicleTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";

export const propertyListTitle = (
	data: ClientPropertyItemResponseDTO,
	t: TranslateFunction,
): string => {
	const title =
		data.property !== ClientPropertyTypeEnum.AutoMoto
			? data.name
			: data.propertyType !== ClientPropertyVehicleTypeEnum.None
				? t(
						Resources.PortfolioDetail.Property.CarPropertyTypeValue[
							data.propertyType as ClientPropertyVehicleTypeEnum
						],
					)
				: "";

	if (title) {
		return title;
	}

	return data.property !== null && data.property !== undefined
		? t(Resources.PortfolioDetail.Property.PropertyType[data.property])
		: "";
};
